import styled from 'styled-components';

const SeenStyled = styled.p(({ theme }) => ({
  marginTop: theme.space[1],
  alignSelf: 'start',
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: theme.font.size.xxsmall,
  color: theme.color.wfGrey600,
}));

export { SeenStyled };
